import styled from 'styled-components';

export const RoutingContainer = styled.div<{ $isAtlasVariant?: boolean }>`
  /* Atlas's global-nav positions itself via a fixed-width margin it applies
     to [data-atlas-gn-app] itself (see its bodyStyles / --atlas-side-nav-width),
     not by taking up flex-row space — so it must be a plain sibling here, not
     a flex item, or the two shifting mechanisms stack and leave a gap. */
  display: ${(props) => (props.$isAtlasVariant ? 'contents' : 'flex')};
  flex-direction: row;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-weight: 100;

  * {
    box-sizing: border-box;
  }
`;

export const RoutingBody = styled.div<{
  moveLeft: boolean;
  $isAtlasVariant?: boolean;
  $suppressAtlasTransition?: boolean;
}>`
  height: 100%;
  /* Atlas's [data-atlas-gn-app] margin-inline-start shifts this element over
     without shrinking its containing block, so a percentage width here would
     overflow by exactly the margin amount — width: auto sizes to the
     remaining space instead, same as any other block-level box. */
  width: ${(props) => (props.$isAtlasVariant ? 'auto' : '100%')};
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  overflow: auto;
  display: flex;
  flex-direction: column;
  margin-left: ${(props) => (props.moveLeft ? '190px' : '0')};
  @media screen and (max-width: 899px) {
    margin-left: 0px;
  }

  /* Atlas animates its own margin-inline-start over 250ms once the nav
     applies its content-shifting body class. On first load that animation
     runs *while* content is also still rendering in (see
     useAtlasNavPositioned) — content pops in already mid-slide and keeps
     sliding as other content loads, reading as jitter rather than a clean
     transition. Suppressing the transition until positioned makes that
     first shift instant; removing this afterwards restores the smooth
     animation for later manual sidebar toggles. */
  ${(props) => props.$suppressAtlasTransition && 'transition: none !important;'}
`;

export const LoginWrapper = styled.div<{ isAppAccount?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: ${(props) =>
    props.isAppAccount
      ? props.theme.atlas.semantic.color.action.secondary.hoverFill
      : props.theme.atlas.semantic.color.surface.inverse};
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
`;
